import React from "react";
import { Link } from "react-router-dom";

function Fullstack() {
  return (
    <>
      <div className=" w-full justify-center text-[#ffff] h-auto bg-no-repeat bg-cover bg-fixed text-center
    pt-40 pb-20  bg-[#6466ec]"
        Style="background-image: url('./image/full-stack/main0.jpg')"
      >
        <p className="py-2 font-semibold text-[#ee2da4] ">Complete Website Services</p>
        <h5 className=" uppercase text-2xl font-bold">
          Full-stack Development Services
        </h5>
        <p className="px-20 py-4">Top companies and startups achieve their business needs by working with MsCube Tech full-stack developers to augment their programming teams for mobile app development, web development, and other software development projects.</p>
        <Link to="/contact">
          <button className="btn  btn-success uppercase text-white duration-600 mt-2 mb-4 mx-2 border-0 rounded-none bg-[#ee2da4] text-sm font-bold px-6 py-2">Get Started </button></Link>
      </div>
      <div className="  container pt-20 ">
        <h5 className="mb-20 text-3xl text-center">
          Full Stack Development Services
        </h5>
        <div className="row">
          <div class="card border-none m-2" Style="width: 22rem;">
            <img src="./image/full1.svg" Style="width: 6rem;" class=" mx-2 px-2 p-0 card-img-top" alt="..." />
            <div class="card-body ">
              <h5 class="card-title font-semibold text-2xl hover:text-[#ee2da4] ">Agile Development</h5>
              <p class="card-text pb-2">Work with Scrum teams using agile methodologies to bring transparency and flexibility to product development. MsCube Tech can help your company easily build a new Scrum team or bring additional talent to an existing one.</p>
            </div>
          </div>

          <div class="card border-none m-2" Style="width: 22rem;">
            <img src="./image/full2.svg" Style="width: 6rem;" class=" mx-2 px-2 p-0 card-img-top" alt="..." />
            <div class="card-body ">
              <h5 class="card-title font-semibold text-2xl hover:text-[#ee2da4] ">Tailored Web Development</h5>
              <p class="card-text pb-2">Having an intuitive and responsive website is the difference between hitting goals and losing engagement. Top developers allow you to effectively improve your performance and scalability by building additional functionalities, integrating APIs, and increasing engagement on site.</p>
            </div>
          </div>

          <div class="card border-none m-2" Style="width: 22rem;">
            <img src="./image/full3.svg" Style="width: 6rem;" class=" mx-2 px-2 p-0 card-img-top" alt="..." />
            <div class="card-body ">
              <h5 class="card-title font-semibold text-2xl hover:text-[#ee2da4] ">Customized Solutions</h5>
              <p class="card-text pb-2">From requirements review to development, MsCube full-stack experts ensure your team will employ the latest technologies in Javascript frameworks (e.g. React.js, Ember.js, Node.js, Backbone.js), mean stack, and database technologies such as MySQL, NoSQL, PostgreSQL, and Mongo DB. </p>
            </div>
          </div>

        </div>
      </div>

      <div className=" w-full justify-center text-[#ffff] h-auto bg-no-repeat bg-cover bg-fixed text-center
    pt-20 "
      >
        <img src="./image/full1.jpg" alt="" />
      </div>
      <div className=" bg-[#00307C] w-full justify-center text-[#000] h-auto bg-no-repeat bg-cover bg-fixed pt-20 ">
        <h5 className="text-[#ffff] font-bold my-4 text-4xl text-center">
          Our Process
        </h5>
        <div className="section2 px-4  ">
          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border hover:bg-[#ee2da4]  hover:text-[#fff] rounded-full text-center pt-2 font-bold w-10 h-10 ml-4 bg-[#000] text-[#ffff]">1</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Define</h5>
              <p class="card-text pb-2">Kick off development by defining all system requirements, making initial technology decisions, and capturing user roles and personas.</p>
            </div>
          </div>

          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border hover:bg-[#ee2da4]  hover:text-[#fff] rounded-full text-center pt-2 font-bold w-10 h-10 ml-4 bg-[#000] text-[#ffff]">2</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Design</h5>
              <p class="card-text pb-2">Determine your product's initial look and feel, model the user experience and user journey, prioritize features, and plan for the release.</p>
            </div>
          </div>

          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border  hover:bg-[#ee2da4]  hover:text-[#fff] rounded-full text-center pt-2 font-bold w-10 h-10 ml-4 bg-[#000] text-[#ffff]">3</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Deliver</h5>
              <p class="card-text pb-2">Move forward with detailed, development-ready specs, time and cost estimates, a launch plan, and a team of MsCube Tech experts ready to execute your plan.</p>
            </div>
          </div>

          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border hover:bg-[#ee2da4]  hover:text-[#fff] rounded-full text-center pt-2 font-bold w-10 h-10 ml-4 bg-[#000] text-[#ffff]">4</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Develop</h5>
              <p class="card-text pb-2">Throughout the product development phase, track quality assurance, DevOps, and deployment updates using the project management tool you prefer.</p>
            </div>
          </div>

        </div>
        <div className="section2 justify-center jus h-auto mt-20 text-[#ffff] bg-[#6a6dec] ">
          <h1 className=" pt-10 px-10 text-white text-2xl">Buil great products with full stack web development service.!</h1>
          <button className="rounded-none border-0 btn btn-success font-bold text-white my-10 mx-10 px-4 py-2 bg-[#ce2e90]">Get Started</button>

        </div>
      </div>

      <div className=" w-full justify-center text-center h-auto pt-20 ">
        <h5 className=" pt-2 text-3xl text-center uppercase font-semibold">
          Projects
        </h5>
        <p className="py-2 uppercase font-semibold">Our latest Complete Projects</p>
        <div className="section2 justify-center text-center m-0 p-0">
          <Link to="/Fullstack-web-development" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/full-stack/multi.png" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">Multi-Vender Online Store </h5>
              </div>
            </div>
          </Link>
          <Link to="https://www.zara.com/" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/full-stack/zara.png" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">Zara Offical Website </h5>
              </div>
            </div>
          </Link>
          <Link to="https://baroque.pk/" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/full-stack/baroque.png" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">Baroque Pk -Ecommerce Website </h5>
              </div>
            </div>
          </Link>

        </div>
        <div className="section2 justify-center text-center m-0 p-0">

          <Link to="/Fullstack-web-development" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/full-stack/pot.png" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">Personal Portfolio Website </h5>
              </div>
            </div>
          </Link>

        </div>
        <div className=" text-center  justify-center pt-40 h-auto  ">
          <h5 className="font-semibold text-3xl text-center">
            Related Services
          </h5>
          <p className="py-2 mb-8">MsCube Tech wide selection of related services are tailored to your company needs and delivered by accomplished experts from our global talent network.</p>
          <div className="row  w-100 justify-center">

            <div class="card border shadow-md hover:bg-[#ee2da4] hover:shadow-lg p-2 hover:text-[#fff] justify-center text-center border-none m-2" Style="width: 20rem;">
              <Link to="/frontend">
                <img src="./image/full.gif" Style="width: 6rem;" class="  px-2 p-0 mx-24 card-img-top" alt="..." />
                <div class="hover:text-[#fff]   ">
                  <h5 class=" font-semibold py-1 text-2xl hover:text-[#fff] ">Front-End Development</h5>
                  <p class="card-text pb-2 font-bold text-xl">Services</p>
                </div>
              </Link>
            </div>

            <div class="card border shadow-md hover:shadow-lg p-2 hover:bg-[#ee2da4]  hover:text-[#fff] justify-center text-center border-none m-2" Style="width: 20rem;">
              <Link to="/product-design">
                <img src="./image/ui.gif" Style="width: 6rem;" class="  px-2 p-0 mx-24 card-img-top" alt="..." />
                <div class="hover:text-[#fff] ">
                  <h5 class=" font-semibold py-1 text-2xl hover:text-[#fff] ">Product Design Services</h5>
                  <p class="card-text pb-2 font-bold text-xl  ">Services</p>
                </div>
              </Link>
            </div>


            <div class="card border shadow-md hover:bg-[#ee2da4] hover:shadow-lg p-2 hover:text-[#fff] justify-center text-center border-none m-2" Style="width: 20rem;">
              <Link to="/app-development">
                <img src="./image/app.gif" Style="width: 6rem;" class="  px-2 p-0 mx-24 card-img-top" alt="..." />
                <div class=" hover:text-[#fff] ">
                  <h5 class=" font-semibold py-1 text-2xl hover:text-[#fff] ">App Development</h5>
                  <p class="card-text pb-2 font-bold text-xl">Services</p>
                </div>
              </Link>
            </div>

          </div>
          <div className="section2  justify-center h-auto mt-24 text-[#ffff] bg-[#6a6dec] ">
            <h1 className=" pt-10 px-10 text-white text-2xl">Buil great products with full stack web development service.!</h1>
            <Link to="/contact">
              <button className="border-0 rounded-none btn btn-success font-bold text-white my-10 mx-10 px-4 py-2 bg-[#ce2e90]">Get Started</button>
            </Link>

          </div>
        </div>

      </div >
    </>
  );
}

export default Fullstack;
